import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { CustomerHistoryId, CustomerHistoryStatus } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-customer-history',
  templateUrl: './customer-history.component.html',
  styleUrls: ['./customer-history.component.css']
})
export class CustomerHistoryComponent implements OnInit {
  customerUpdateHistory : any;
  totalCount : any = 0;
  constructor(private customerService: CustomerService) { }

  ngOnInit(): void {
    this.customerHistory();
  }

  async customerHistory()
  {
    await this.customerService.getCustomerUpdateHistory().then((response) => {
      this.customerUpdateHistory = response;
      if(this.customerUpdateHistory)
      {
        this.customerUpdateHistory.forEach(element => {
          element.createdDate = Utility.ConvertUTCDateToLocalDate(element.createdDate);
        });
      }
      this.totalCount = this.customerUpdateHistory.length;
    });
  }
  getType(key:number):string {
    switch(key)
    {
      case CustomerHistoryId.Email : 
        return CustomerHistoryStatus.Email
      case CustomerHistoryId.MobileNo :
        return CustomerHistoryStatus.MobileNo
      case CustomerHistoryId.FirstName : 
        return CustomerHistoryStatus.FirstName
      case CustomerHistoryId.LastName :
        return CustomerHistoryStatus.LastName
      case CustomerHistoryId.Address1 : 
        return CustomerHistoryStatus.Address1
      case CustomerHistoryId.Zipcode :
        return CustomerHistoryStatus.Zipcode
      case CustomerHistoryId.City : 
        return CustomerHistoryStatus.City
      case CustomerHistoryId.Country :
        return CustomerHistoryStatus.Country
      case CustomerHistoryId.IsMarketingConsent : 
        return CustomerHistoryStatus.IsMarketingConsent
      case CustomerHistoryId.IsSms :
        return CustomerHistoryStatus.IsSms
      case CustomerHistoryId.IsEmail :
        return CustomerHistoryStatus.IsEmail
      case CustomerHistoryId.IsPhone :
        return CustomerHistoryStatus.IsPhone
      case CustomerHistoryId.CustomerGroup :
        return CustomerHistoryStatus.CustomerGroup
      case CustomerHistoryId.CustomerTypeId : 
        return CustomerHistoryStatus.CustomerTypeId
      case CustomerHistoryId.PreferredDealerId :
        return CustomerHistoryStatus.PreferredDealerId
      case CustomerHistoryId.PaymentTermsCode :
        return CustomerHistoryStatus.PaymentTermsCode
      case CustomerHistoryId.ReminderTermsCode :
        return CustomerHistoryStatus.ReminderTermsCode 
      case CustomerHistoryId.PaymentMethodCode :
        return CustomerHistoryStatus.PaymentMethodCode 
      case CustomerHistoryId.isCompanyNameChanged :
        return CustomerHistoryStatus.isCompanyNameChanged 
    }
  }
  
  ngOnDestroy():void {
    this.totalCount = 0;
  }
}
